export const BrandLockup = () => (
  <div className="brand-lockup" data-testid="brand-lockup">
    <img
      className="brand-lockup-image"
      src="/assets/brand/explordio-logo-say-it.png"
      alt="Explordio — Explore, Say It, Play It"
      data-testid="brand-logo-lockup-image"
    />
  </div>
);